import styled from '@emotion/styled'

export const LineItemContainer = styled.div`
  display: flex;
  flex: 1;
  gap: 16px;
  padding-bottom: 15px;
  color: #555;
`

export const LineItemLeft = styled.div`
  display: flex;
  flex: 1;
  gap: 16px;
  justify-content: left;
`

export const LineItemRight = styled(LineItemLeft)`
  justify-content: right;
`

export const TotalLineItemContainer = styled(LineItemContainer)`
  border-top: 1px solid #eaeaea;
  padding-top: 15px;
  font-weight: 700;
  color: unset;
`
